var render, staticRenderFns
import script from "./KDecimal.vue?vue&type=script&lang=js"
export * from "./KDecimal.vue?vue&type=script&lang=js"
import style0 from "./KDecimal.vue?vue&type=style&index=0&id=459d8e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d8e06",
  null
  
)

export default component.exports